var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCake = function SvgCake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.125V8",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8H16.25C16.5815 8 16.8995 8.1317 17.1339 8.36612C17.3683 8.60054 17.5 8.91848 17.5 9.25V11.0727C17.5 12.4352 16.432 13.5867 15.0703 13.6242C14.7362 13.6336 14.4036 13.5759 14.0922 13.4546C13.7808 13.3332 13.4968 13.1506 13.2572 12.9176C13.0176 12.6846 12.8271 12.4059 12.697 12.098C12.567 11.7901 12.5 11.4592 12.5 11.125C12.5 11.788 12.2366 12.4239 11.7678 12.8928C11.2989 13.3616 10.663 13.625 10 13.625C9.33696 13.625 8.70107 13.3616 8.23223 12.8928C7.76339 12.4239 7.5 11.788 7.5 11.125C7.50013 11.4593 7.43321 11.7902 7.3032 12.0982C7.17319 12.4062 6.98273 12.685 6.74308 12.9181C6.50344 13.1512 6.21948 13.3338 5.908 13.4553C5.59653 13.5767 5.26386 13.6344 4.92969 13.625C3.56797 13.5867 2.5 12.4352 2.5 11.0727V9.25C2.5 8.91848 2.6317 8.60054 2.86612 8.36612C3.10054 8.1317 3.41848 8 3.75 8Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.7578V16.125C16.875 16.4565 16.7433 16.7745 16.5089 17.0089C16.2745 17.2433 15.9565 17.375 15.625 17.375H4.375C4.04348 17.375 3.72554 17.2433 3.49112 17.0089C3.2567 16.7745 3.125 16.4565 3.125 16.125V12.7578",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 4.25C11.875 4.74728 11.6775 5.22419 11.3258 5.57583C10.9742 5.92746 10.4973 6.125 10 6.125C9.50272 6.125 9.02581 5.92746 8.67417 5.57583C8.32254 5.22419 8.125 4.74728 8.125 4.25C8.125 2.375 10 1.125 10 1.125C10 1.125 11.875 2.375 11.875 4.25Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCake;